import React, { useEffect, useState } from 'react';
import { initiateGoogleLogin, handleAuthCallback, getCurrentUser, logout, type User } from '../../services/api';

export const AuthButton: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Handle OAuth callback
    const token = handleAuthCallback();

    // Try to get current user if token exists
    const checkAuth = async () => {
      try {
        const currentUser = await getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        // Not authenticated, that's ok
        console.log('Not authenticated');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogin = () => {
    initiateGoogleLogin();
  };

  const handleLogout = () => {
    logout();
    setUser(null);
  };

  if (loading) {
    return (
      <div className="auth-button loading">
        <span>Loading...</span>
      </div>
    );
  }

  if (user) {
    return (
      <div className="auth-button authenticated">
        <div className="user-info">
          {user.avatar_url && (
            <img
              src={user.avatar_url}
              alt={user.name || user.email}
              className="user-avatar"
              style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '8px' }}
            />
          )}
          <span className="user-name">{user.name || user.email}</span>
        </div>
        <button
          onClick={handleLogout}
          className="logout-button"
          style={{
            marginLeft: '12px',
            padding: '6px 12px',
            background: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Logout
        </button>
      </div>
    );
  }

  return (
    <div className="auth-button unauthenticated">
      <button
        onClick={handleLogin}
        className="login-button"
        style={{
          padding: '8px 16px',
          background: '#4285f4',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
          <path fill="#fff" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
          <path fill="#fff" d="M9.003 18c2.43 0 4.467-.806 5.956-2.18L12.05 13.56c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18z"/>
          <path fill="#fff" d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z"/>
          <path fill="#fff" d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.003 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z"/>
        </svg>
        Sign in with Google
      </button>
    </div>
  );
};

export default AuthButton;
